// src/modules/whatsApp/api.js
// API client for the WhatsApp AI-bot module. Talks to /api/v1/whatsapp on the
// backend (routes/v1/whatsappRoutes.js). The webhook endpoints are Meta-facing
// and never called from here.
import API from '../../services/api';

const base = '/whatsapp';

// ── Config (admin) ──
export const getWhatsAppConfig = () => API.get(`${base}/config`);
export const updateWhatsAppConfig = (payload) => API.put(`${base}/config`, payload);

// ── Inbox (authed agents) ──
export const fetchWhatsAppContacts = (params) => API.get(`${base}/contacts`, { params });
export const fetchWhatsAppThread = (waId, params) => API.get(`${base}/contacts/${waId}`, { params });
// Free-form agent reply. Server refuses (409) outside the 24-hour window.
export const sendWhatsAppMessage = (waId, text) => API.post(`${base}/contacts/${waId}/send`, { text });
// Mute the bot on a thread when an agent takes it over from the CRM.
export const takeoverWhatsAppThread = (waId) => API.post(`${base}/contacts/${waId}/takeover`);
